import gql from 'graphql-tag'

import { responsiveImageFragment } from '../fragments/images.js'
import { seoFragment } from '../fragments/seo.js'
import { cardCarouselFragment, centeredMediaBlockFragment, videoBlockFragment, sectionFragment, slimBannerFragment, textImageBlockFragment, timelineBlockFragment, zoomMasonryFragment } from '../fragments/body.js'
import { heroFragment } from '../fragments/hero.js'

export const getSavoirFaire = gql`
  ${responsiveImageFragment}
  ${seoFragment}
  ${heroFragment}
  ${zoomMasonryFragment}
  ${slimBannerFragment}
  ${sectionFragment}
  ${textImageBlockFragment}
  ${centeredMediaBlockFragment}
  ${videoBlockFragment}
  ${cardCarouselFragment}
  ${timelineBlockFragment}
  query getSavoirFaire($locale: SiteLocale) {
    savoirFaire(locale: $locale) {
      seo {
        ...SeoFragment
      }
      hero {
        ...HeroFragment
      }
      body {
        __typename
        ... on ZoomMasonryRecord {
          ...ZoomMasonryFragment
        }
        ... on SlimBannerRecord {
          ...SlimBannerFragment
        }
        ... on SectionRecord {
          ...SectionFragment
        }
        ... on TextImageBlockRecord {
          ...TextImageBlockFragment
        }
        ... on CenteredMediaBlockRecord {
          ...CenteredMediaBlockFragment
        }
        ... on VideoBlockRecord {
          ...VideoBlockFragment
        }
        ... on CardCarouselRecord {
          ...CardCarouselFragment
        }
        ... on TimelineBlockRecord {
          ...TimelineBlockFragment
        }
      }
    }
  }
`
